import { useQuery } from '@tanstack/react-query';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';

export const useHeaderMenuQuery = () =>
    useQuery({
        queryKey: ['header-menu'],
        staleTime: Infinity,
        queryFn: async () => {
            const customService = container.resolve<ICustomConfigurationService>(
                DI.SERVICES.ICustomConfigurationService
            );
            const response = await customService.getHeaderMenuContent();
            return response?.data;
        },
    });
